'use client'

// src/ArrowForward.tsx
import { createIcon } from "@chakra-ui/icon";
var ArrowForwardIcon = createIcon({
  d: "M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z",
  displayName: "ArrowForwardIcon"
});

export {
  ArrowForwardIcon
};
//# sourceMappingURL=chunk-XEKRR764.mjs.map